<template>
  <section class="section is-main-section">
    <circul8-table
      :records="data"
      :fields="columns"
      :usePropRecords="true"
      :listingComponent="true"
      :isCheckable="true"
      :maxTextLength="'24'"
      :isLoading="isDataLoading"
      :backendSortingEnabled="true"
      @clickEdit="clickEditPlayground"
      @clickView="clickViewPlayground"
      @backendSort="sortData"
      :showRemoveButton="isEditAllowed"
      :showEditButton="true"
      :routeNext="false"
      @querySet="searchByFilter"
      @loadNextPage="pullNextPage"
      :enableInfiniteScroll="true"
      :hasNextData="nextData"
      :hasPreviousData="previousData"
      @loadPreviousPage="pullPreviousPage"
      @clickDelete="deleteModal"
      :saveDataFields="true"
      :tableName="tblName"
    />
    <div class="records-displayed" v-if="totalRecords > 0">
      <span v-if="currentPage * 50 + 50 < totalRecords"
        >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
        {{
          currentPage > 0
            ? nextPageCursor
              ? currentPage * 50 - 50 + data.length
              : totalRecords
            : data.length
        }}
        records out of {{ totalRecords }} records</span
      >
      <div v-else>
        <span v-if="currentPage == 0">
          displaying 0 - {{ totalRecords }} records out of
          {{ totalRecords }} records
        </span>
        <span v-else>
          displaying {{ currentPage * 50 - 50 }} - {{ totalRecords }} records
          out of {{ totalRecords }} records
        </span>
      </div>
    </div>
  </section>
</template>

<script>
import Circul8Table from "../../../components/Circul8Table.vue";
import * as dayjs from "dayjs";
import PlaygroundService from "../../../services/PlaygroundService";

export default {
  name: "PlaygroundListView",
  components: { Circul8Table },
  props: {
    customer_id: {
      type: Number,
      default: null
    },
    newDataAdded: {
      type: Array,
      default: null
    },
    presetDropDownList: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      tblName: "PlaygroundListView",
      data: [],
      isEditAllowed: true,
      PlaygroundService: new PlaygroundService(),
      isDataLoading: false,
      isModalActive: false,
      action: null,
      isAdd: false,
      editObject: this.getClearFormObject(),
      viewOnly: false,
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      totalRecords: 0,
      isLoading: true,
      nextData: false,
      previousData: false,
      currentPage: 0,
      query: "",
      columns: [
        {
          field: "playground_name",
          label: "Playground Name",
          searchable: true,
          searchKey: "playground_name",
          type: "input",
          filterKey: { playground_name: "" }
        },
        {
          field: "period",
          label: "Period",
          searchable: true,
          searchKey: "period",
          type: "input",
          filterKey: { period: "" }
        },
        {
          field: "top_metric",
          label: "Top Metric",
          searchable: true,
          searchKey: "top_metric",
          type: "input",
          filterKey: { top_metric: "" }
        },
        {
          field: "preset_scenario",
          label: "Playground Scenario",
          searchable: true,
          visible: true,
          searchKey: "preset_scenario",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          initStatusVals: [],
          allStatusVals: this.presetList,
          filterKey: { preset_scenario: [] }
        },

        // {
        //   field: "from_date",
        //   label: "From Date",
        //   searchable: true,
        //   dateField: true,
        //   type: "dateField",
        //   dateFilterKey: "from_date_key",
        //   filterKey: { to_date: [] }
        // },
        // {
        //   field: "to_date",
        //   label: "To Date",
        //   searchable: true,
        //   dateField: true,
        //   type: "dateField",
        //   dateFilterKey: "to_date_key",
        //   filterKey: { to_date: [] }
        // },
        {
          field: "last_update",
          label: "Last Update",
          searchable: true,
          dateField: true,
          type: "dateField",
          dateFilterKey: "last_update_key",
          filterKey: { last_update: [] }
        },
        {
          field: "updated_by",
          label: "Updated By",
          searchable: true,
          searchKey: "period",
          type: "input",
          filterKey: { updated_by: "" }
        },
        {
          field: "status",
          label: "Status",
          searchable: true,
          searchKey: "status",
          type: "input",
          filterKey: { status: "" }
        },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions",
          visible: true,
          searchable: true,
          type: "actionSearch",
          actionSearch: true,
          filterKey: { actions: "" }
        }
      ]
    };
  },
  watch: {
    customer_id() {
      this.getPlaygroundList();
    },
    newDataAdded() {
      this.getPlaygroundList();
    },
    presetDropDownList(newValue) {
      this.columns = this.columns.map(col => {
        if (col.field === "preset_scenario") {
          col.allStatusVals = newValue;
        }
        return col;
      });
    }
  },
  methods: {
    getPlaygroundList(query = "", scrollDir) {
      this.isDataLoading = true;
      this.isLoading = true;
      this.data = [];
      this.PlaygroundService.getPlaygroundList(
        query,
        this.customer_id
      ).subscribe(
        response => {
          this.PreviousPageCursor = this.nextPageCursor
            ? this.nextPageCursor
            : this.PreviousPageCursor;
          this.nextPageCursor = response["next"];
          if (this.currentPage > 1) {
            this.previousData = true;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          } else {
            this.enableLoadMore = this.previousData = false;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          }
          this.totalRecords = response["count"];
          let tempData = [];
          if (scrollDir == "next") {
            if (!this.nextPageCursor) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...this.data, ...response["results"]];
              if (tempData.length > 100 && this.nextPageCursor != null) {
                tempData = tempData.slice(50, 150);
              }
              this.prepareData(tempData);
            }
          } else if (scrollDir == "prev") {
            if (this.currentPage == 0) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...response["results"], ...this.data];
              if (tempData.length >= 100) {
                tempData = tempData.slice(0, 100);
              }
              this.prepareData(tempData);
            }
          } else {
            this.prepareData(response["results"], scrollDir);
          }
          this.isLoading = false;
        },
        e => {
          console.log(e);
          this.isDataLoading = false;
          this.isLoading = false;
          this.nextData = false;
        }
      );
    },

    // convertDateStringToObject() {
    //   const from_date = this.find_column_index("from_date");
    //   if (this.columns[from_date].filterKey.from_date.length) {
    //     this.columns[from_date].filterKey.from_date[0] = new Date(
    //       this.columns[from_date].filterKey.from_date[0]
    //     );
    //     this.columns[from_date].filterKey.from_date[1] = new Date(
    //       this.columns[from_date].filterKey.from_date[1]
    //     );
    //   }

    //   const to_date = this.find_column_index("to_date");
    //   if (this.columns[to_date].filterKey.to_date.length) {
    //     this.columns[to_date].filterKey.to_date[0] = new Date(
    //       this.columns[to_date].filterKey.to_date[0]
    //     );
    //     this.columns[to_date].filterKey.to_date[1] = this.convertToDateObject(
    //       this.columns[to_date].filterKey.to_date[1]
    //     );
    //   }
    // },
    convertToDateObject(date) {
      if (date) {
        return new Date(date);
      }
    },
    find_column_index(column_name) {
      if (this.columns) {
        return this.columns.findIndex(col => col.field === column_name);
      }
      return null;
    },
    getClearFormObject() {
      return {
        id: null,
        playground_name: null,
        period: null,
        top_metric: null,
        from_date: null,
        to_date: null
      };
    },

    prepareData(data) {
      const dataList = [];
      for (const report in data) {
        const reportData = data[report];
        reportData["updated_at"] = dayjs(reportData["updated_at"]).format(
          "YYYY-MM-DD, HH:mm"
        );
        const preset_scenario = this.presetDropDownList.filter(
          i => i.id == reportData["preset_scenario"]
        );
        reportData["preset_scenario"] = preset_scenario[0].name;
        reportData["actions"] = this.isEditAllowed;
        reportData["delete"] = this.isEditAllowed;
        dataList.push(reportData);
      }

      if (this.nextPageCursor == null) {
        this.data.push(...dataList);
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        this.data = dataList;
      }
      this.isDataLoading = false;
    },
    pullNextPage() {
      this.previousData = true;
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;
      const temp = this.nextPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query =
          "&" + query_part.join("&") + "&page=" + (this.currentPage + 1) + "&";
        this.getPlaygroundList(this.query, "next");
      }
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;
      const temp = this.PreviousPageCursor.split("?")[1].split("&");
      let query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      query_part = [...new Set(query_part)];
      if (this.currentPage == 0 || this.currentPage == 1) {
        this.query = "&" + query_part.join("&") + "&page=1&";
        this.previousData = false;
      } else {
        this.query =
          "&" + query_part.join("&") + "&page=" + this.currentPage + "&";
      }
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.getPlaygroundList(this.query, "prev");
    },
    searchByFilter(filterQuery) {
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.data = [];
      this.nextData = false;
      this.query = "&" + filterQuery;
      //      this.displayedRecords = 0;

      let query = "";
      if (this.lastSortColumn) {
        query += "&order_field" + "=" + this.lastSortColumn;
        query += "&order_by" + "=" + this.lastSortOrder;
        query += this.query;
      } else {
        query = this.query;
      }
      this.getPlaygroundList(query);
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.data = [];
      this.nextData = false;
      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      const oldOrderField = "&order_field" + "=" + this.lastSortColumn;
      const oldOrderValue = "&order_by" + "=" + this.lastSortOrder;
      const newOrderField = "&order_field" + "=" + field;
      const newOrderValue = "&order_by" + "=" + order;

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      //     this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.getPlaygroundList(this.query);
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },

    deleteModal(editObject) {
      this.$buefy.dialog.confirm({
        title: "Deleting Playground",
        message: "Are you sure you want to <b>delete</b> this Playground?",
        confirmText: "Delete Playground",
        type: "is-danger",
        onConfirm: () => this.deletePlayground(editObject)
      });
    },
    deleteScope(editObject) {
      try {
        this.RulesManagerService.deletePlayground(editObject).subscribe(
          () => {
            this.$buefy.toast.open("Playground deleted!");
            this.data = [];
            this.getPlaygroundList(this.query);
          },
          e => {
            this.handleApiError(e);
            this.isDataLoading = false;
          }
        );
      } catch (e) {
        this.handleApiError(e);
        this.isDataLoading = false;
      }
    },

    clickEditPlayground(editObject) {
      console.log(editObject, "editObject");
    },

    clickViewPlayground(editObject) {
      console.log(editObject, "editObject");
    }
  }
};
</script>
